import React from "react";
import "./OrderCard";
import { MedDetailsWrap, MedSubBtn } from "../../PickerOrder/PickerOrder.style";
import packageIcon from "../../../assets/icons/package.png";
import IncrementDecrementInput from "../../../components/IncrementDecrementInput/IncrementDecrementInput";
class OrderCard extends React.Component {
  render() {
    return (
      <div
        style={{
          border: "1px solid #cacaca",
          margin: "15px 0px",
          borderRadius: "4px",
          // boxShadow: "0 2px 8px rgb(28 28 28 / 14%)",
          padding: "6px",
        }}
      >
        <div
          style={{
            marginBottom: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span style={{ fontWeight: "600", fontSize: "16px" }}>
            Order Id: {this.props.details.orderId}
          </span>
          {this.props.type !== 2 ? (
            <img
              src={packageIcon}
              alt="pick"
              style={{
                width: "35px",
                opacity: this.props.details.activeMed ? "0.5" : "1",
                pointerEvents: this.props.details.activeMed ? "none" : "auto",
              }}
              onClick={() => this.props.pickedMeds(this.props.details)}
            />
          ) : null}
        </div>

        {this.props.details.MedList.map((med, medKey) => (
          <MedDetailsWrap>
            <div className="medTitleWrap">
              <div className="medTitle">{med.name}</div>
            </div>
            <div className="batchWrap">
              {med.batches?.length > 0 ? (
                med.batches.map((f, j) => {
                  return (
                    <div className="batchDetailsWrap">
                      <div className="name">{f.batchNumber}</div>
                      <div className="qty">{f.ogQty}</div>
                      {this.props.type !== 2 ? (
                        <div className="editQty">
                          <IncrementDecrementInput
                            disabled={!this.props.details.activeMed}
                            min={0}
                            max={f.ogQty}
                            value={f.quantity}
                            step={1}
                            handleChange={(qty) => {
                              this.props.handleBatchEdit(
                                qty,
                                this.props.ind,
                                medKey,
                                j
                              );
                            }}
                          />
                        </div>
                      ) : null}
                    </div>
                  );
                })
              ) : (
                <div>No Batches Found</div>
              )}
            </div>
          </MedDetailsWrap>
        ))}
        {this.props.type !== 2 ? (
          <MedSubBtn
            onClick={() =>
              this.props.editMedDetails(
                this.props.details,
                this.props.details.activeMed ? false : true
              )
            }
          >
            {this.props.details.activeMed ? "Save" : "Edit"}
          </MedSubBtn>
        ) : null}
      </div>
    );
  }
}

export default OrderCard;
